/* eslint-disable react/no-danger */
/* eslint-disable no-underscore-dangle */
import ModalMaterialUi from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { Button } from "components/core";
import "react-quill/dist/quill.bubble.css"; // ES6
import styled from "styled-components";
import { TERM_AND_CONDITIONS } from "constants/index";
import { useGlobalContext } from "context/GlobalContext";

const Modal = styled(ModalMaterialUi)`
  display: flex;
  align-items: center;
  justify-content: center;

  .body {
    border: 2px solid #ddd;
    padding: 16px 32px 24px;
    box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%),
      0px 5px 8px 0px rgb(0 0 0 / 14%), 0px 1px 14px 0px rgb(0 0 0 / 12%);
    background-color: #fff;

    width: 100vw;
    height: 100vh;
    overflow: scroll;
    max-width: 480px;
    max-height: 480px;
    border-radius: 8px;
  }
`;

export const ModalLegal = () => {
  const gContext = useGlobalContext();

  if (!gContext.legalModalVisible) {
    return null;
  }

  return (
    <Modal
      title="Información de usuario"
      open={gContext.legalModalVisible}
      onClose={gContext.toggleLegalModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={gContext.legalModalVisible}>
        <div className="body">
          <h2 className="tc">Términos y condiciones</h2>
          <div
            className="ql-editor"
            dangerouslySetInnerHTML={{ __html: TERM_AND_CONDITIONS }}
          />
          <Button onClick={gContext.toggleLegalModal}>Ok</Button>
        </div>
      </Fade>
    </Modal>
  );
};
